var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_layout clearfix"},[_c('app-header',{attrs:{"isPageLayer":true}},[_c('h1',{staticClass:"logo",attrs:{"slot":"extra"},slot:"extra"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('i',{staticClass:"icon icon--logo-new"})])],1)]),_c('router-view',{staticClass:"content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }